import { render, staticRenderFns } from "./_BasicLayout.vue?vue&type=template&id=09781aba&"
import script from "./_BasicLayout.vue?vue&type=script&lang=ts&"
export * from "./_BasicLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports